import { MeiliSearch } from 'meilisearch';
import { generateTenantToken } from 'meilisearch/token';
import axios from 'axios';
import axiosRetry from 'axios-retry';
class MeiliSearchClient extends MeiliSearch {
    static createAxiosInstance(config) {
        const axiosInstance = axios.create({
            timeout: config.timeout ?? 5000
        });
        axiosRetry(axiosInstance, {
            retries: config.retries ?? 3,
            retryDelay: () => 0,
            retryCondition: (error) => {
                const isTimeout = error.code === 'ECONNABORTED' || error.message?.includes('timeout');
                const isNetworkError = axiosRetry.isNetworkOrIdempotentRequestError(error);
                console.log('[MeiliSearchClient] Retry condition check:', {
                    errorMessage: error.message,
                    isTimeout,
                    isNetworkError,
                    willRetry: isTimeout || isNetworkError
                });
                return isTimeout || isNetworkError;
            },
            onRetry: (error, attempt, requestConfig) => {
                const message = typeof error === 'object' && error !== null && 'message' in error ? error.message : String(error);
                console.warn(`[MeiliSearchClient] Retry attempt #${attempt} for ${requestConfig?.url}: ${message}`, {
                    body: requestConfig?.data
                });
            },
            shouldResetTimeout: true
        });
        return axiosInstance;
    }
    constructor(config) {
        const axiosInstance = MeiliSearchClient.createAxiosInstance(config);
        super({
            ...config,
            httpClient: async (url, opts) => {
                const method = (opts?.method ?? 'GET').toUpperCase();
                // Log when the request is triggered
                console.log(`[MeiliSearchClient] ${method} request to ${url} triggered`, {
                    body: opts?.body
                });
                try {
                    const response = await axiosInstance.request({
                        url,
                        method,
                        headers: opts?.headers
                            ? (() => {
                                if (typeof window !== 'undefined') {
                                    // Browser environment
                                    const headers = new Headers(opts.headers);
                                    const result = {};
                                    headers.forEach((value, key) => {
                                        result[key.toLowerCase()] = value;
                                    });
                                    return result;
                                }
                                // Node.js environment
                                return Object.fromEntries(Object.entries(opts.headers).map(([key, value]) => [key.toLowerCase(), value]));
                            })()
                            : undefined,
                        data: opts?.body
                    });
                    // Log after request is done
                    console.log(`[MeiliSearchClient] ${method} request to ${url} completed with status ${response.status}`);
                    return response.data;
                }
                catch (error) {
                    // Log the error but don't rethrow it yet to allow retry mechanism to work
                    const errorMessage = error instanceof Error ? error.message : String(error);
                    console.error(`[MeiliSearchClient] Error in ${method} request to ${url}: ${errorMessage}`);
                    // Rethrow the error to allow retry mechanism to work
                    throw error;
                }
            }
        });
    }
}
export * from 'meilisearch';
export { MeiliSearchClient as MeiliSearch };
export { generateTenantToken };
//# sourceMappingURL=index.js.map